import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Tag } from '@pwc/appkit-react/lib/Tag';
import { Tooltip } from '@pwc/appkit-react/lib/Tooltip';

const MultiValue = props => {
  const { data, removeProps, selectProps } = props;
  const disabled = Boolean(selectProps && selectProps.isDisabled);

  const onClose = useCallback(event => {
    if (removeProps && removeProps.onClick) {
      removeProps.onClick(event);
    }
  }, [removeProps]);

  const tag = (
    <Tag
      onClose={onClose}
      disabled={disabled}
      id={data.value}
      size="sm"
      className="Select__multi-value"
      closeable={!disabled}
    >
      {data.label}
    </Tag>
  );

  if (data.tooltip) {
    return (
      <Tooltip content={data.tooltip} placement="top">
        {tag}
      </Tooltip>
    );
  }

  return tag;
};

MultiValue.propTypes = {
  data: PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    tooltip: PropTypes.string,
  }).isRequired,
  removeProps: PropTypes.shape({
    onClick: PropTypes.func,
  }),
  selectProps: PropTypes.object, // eslint-disable-line react/forbid-prop-types
};

export default MultiValue;
